import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { MailingAddressForm } from './mailingAddress/MailingAddressForm';
import { CardShipmentSelection } from './components/CardShipmentSelection';
import { useCardShipmentLogic, CARD_SHIPMENT_FIELD } from './hooks/useCardShipmentLogic';

export const MailingAddress = () => {
  const { t } = useTranslation();
  const { isPending, formMethods, handleSubmit, options, showMailingForm, usStates } =
    useCardShipmentLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isPending}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={t('sectionTitles.businessDetails')}
        content={t('pages.cardShipment.title')}>
        <CardShipmentSelection options={options} fieldName={CARD_SHIPMENT_FIELD} />
        {showMailingForm && (
          <div className='mt-[24px]'>
            <MailingAddressForm disabled={false} usStates={usStates} />
          </div>
        )}
      </StepPageWrapper>
    </FormProvider>
  );
};
